module.exports = __webpack_public_path__ + "img/删除.f259a19e.png";